import { render, staticRenderFns } from "./UpdateTransferMedical.vue?vue&type=template&id=cdf93592&scoped=true&"
import script from "./UpdateTransferMedical.vue?vue&type=script&lang=ts&"
export * from "./UpdateTransferMedical.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateTransferMedical.vue?vue&type=style&index=0&id=cdf93592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf93592",
  null
  
)

export default component.exports